import { render } from "./FormSeparator.vue?vue&type=template&id=d2b576f0"
import script from "./FormSeparator.vue?vue&type=script&lang=js"
export * from "./FormSeparator.vue?vue&type=script&lang=js"

import "./FormSeparator.vue?vue&type=style&index=0&id=d2b576f0&lang=less"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__